import React, { useState } from 'react';
import ProChart from '../ProChart';
import DepthChart from './DepthChart';
import TokenInfo from './TokenInfo';
import { lsGet, lsSet } from './format';
import './pro.css';

// Chart area tabs: candlesticks, depth, market info.
// `extra` adds one more tab (the phone layout puts the order book here); its
// node stays mounted while hidden.
export default function ChartPanel({ token, PecuPrice, USXMPrice, extra }) {
  const [stored, setView] = useState(() => lsGet('hd_chart_view', 'chart'));
  const view = stored === 'book' && !extra ? 'chart' : stored;
  const pick = (v) => {
    setView(v);
    lsSet('hd_chart_view', v);
  };
  const display = token?.identitySymbol || token?.token_symbol || token?.symbol;
  const orderSymbol = token?.symbol || token?.token_symbol || token?.identitySymbol;
  return (
    <div className="x-chartpanel">
      <div className="x-tabs x-tabs-sm">
        {[
          ['chart', 'Chart'],
          ['depth', 'Depth'],
          ['info', 'Info'],
          ...(extra ? [[extra.key, extra.label]] : [])
        ].map(([k, l]) => (
          <button key={k} type="button" className={view === k ? 'x-tab x-active' : 'x-tab'} onClick={() => pick(k)}>
            {l}
          </button>
        ))}
      </div>
      {/* Keep the candle chart mounted so switching tabs doesn't refetch. */}
      <div style={{ display: view === 'chart' ? 'block' : 'none' }}>
        <ProChart symbol={display} chartSymbol={token?.symbol || token?.token_symbol} />
      </div>
      {view === 'depth' && (
        <DepthChart orderSymbol={orderSymbol} refPrice={token?.currentPrice ?? token?.token_price} />
      )}
      {view === 'info' && <TokenInfo token={token} PecuPrice={PecuPrice} USXMPrice={USXMPrice} />}
      {extra && <div style={{ display: view === extra.key ? 'block' : 'none' }}>{extra.node}</div>}
    </div>
  );
}
